"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var codec_1 = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var gateway_request_type_1 = require("./../../services/gateway-control/gateway-request-type");
var base_gateway_service_request_1 = require("./../../services/gateway-control/services/base-gateway-service-request");
var service_id_serialiser_1 = require("./../../services/gateway-control/services/service-id-serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
var service_detail_serialiser_1 = require("./services/service-detail-serialiser");
var UnknownGatewayRequestTypeError = /** @class */ (function (_super) {
    __extends(UnknownGatewayRequestTypeError, _super);
    function UnknownGatewayRequestTypeError(request) {
        return _super.call(this, "Cannot serialise unknown gateway request type: " + request.type) || this;
    }
    return UnknownGatewayRequestTypeError;
}(Error));
exports.UnknownGatewayRequestTypeError = UnknownGatewayRequestTypeError;
/**
 * Serialiser for {@link GatewayClientRequestSerialiser}
 */
var GatewayClientRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientRequestSerialiserClass, _super);
    function GatewayClientRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link GatewayClientRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayClientRequest} to be written
     */
    GatewayClientRequestSerialiserClass.prototype.write = function (bos, value) {
        if (value.type in gateway_request_type_1.GatewayRequestType) {
            // Only write headers for known types
            session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionId);
            BEES.write(bos, value.type);
            if (value instanceof base_gateway_service_request_1.BaseGatewayServiceRequest) {
                service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.serviceId);
            }
        }
        switch (value.type) {
            case gateway_request_type_1.GatewayRequestType.GET_CONFIGURATION:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_CONFIGURATION:
            case gateway_request_type_1.GatewayRequestType.GET_STATUS:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_STATUS:
            case gateway_request_type_1.GatewayRequestType.GET_OPERATIONS:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATIONS:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICES:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES:
                // These requests don't have parameters other than the target client/service.
                break;
            case gateway_request_type_1.GatewayRequestType.ADD_SERVICE:
            case gateway_request_type_1.GatewayRequestType.UPDATE_SERVICE:
                service_detail_serialiser_1.GatewayServiceSerialiser.write(bos, value.serviceDetails);
                break;
            case gateway_request_type_1.GatewayRequestType.REMOVE_SERVICE:
                service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.serviceId);
                break;
            case gateway_request_type_1.GatewayRequestType.GET_OPERATION_DETAIL:
            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATION_DETAIL:
                codec_1.writeString(bos, value.operationName);
                break;
            case gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION:
            case gateway_request_type_1.GatewayRequestType.INVOKE_SERVICE_OPERATION:
                codec_1.writeString(bos, value.operationName);
                // tslint:disable-next-line:strict-type-predicates
                if (value.input === null || value.input === undefined) {
                    codec_1.writeByte(bos, 0);
                }
                else {
                    codec_1.writeByte(bos, 1);
                    codec_1.writeString(bos, value.input);
                }
                break;
            default:
                // Compile time completeness check and run time exception
                throw new UnknownGatewayRequestTypeError(value);
        }
    };
    return GatewayClientRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientRequestSerialiserClass = GatewayClientRequestSerialiserClass;
/**
 * The {@link GatewayClientRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayClientRequestSerialiser = new GatewayClientRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/gateway-client-request-serialiser.js
// module id = 582
// module chunks = 1